import { object, string, number, date, InferType } from "yup";
import * as Yup from "yup";

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phonePattern = /^[0-9]{10}$/;

  function generateInviteCode() {
  return Math.floor(100000 + Math.random() * 900000).toString();
}

export const formiksignup = {
  initialValues: {
    firstName: "",
    lastName: "",
    email: "",
    primaryPhone: "",
    gender: "",
    dob: "",
    countyrOpractice: "",
    medicalSpeciality:"",
    medicalSetting: "",
    archived: false,
    active: false,
    role: "DOCTOR",
    terms: false,
    terms1: false,
    invideCode: generateInviteCode(),

  },
  validationSchema: Yup.object({
    email: Yup.string()
      .matches(emailPattern, "Enter a valid email address")
      .required("Required Field"),
    firstName: Yup.string().required("Required Field"),
    lastName: Yup.string().required("Required Field"),
    primaryPhone: Yup.string()
      .matches(phonePattern, "Enter a valid 10 digit phone number")
      .required("Required Field"),
    gender: Yup.string().required("Required Field"),
    terms: Yup.string().required("Required Field"),
    terms1: Yup.string().required("Required Field"),
    // allow 6 digit invite code 
    invideCode: Yup.string()
      .matches(/^[0-9]{6}$/, "Invite code must be 6 digits long")

    
  }),
};
